import React from 'react';
import { sectors } from '../mock/data';
import { useI18n } from '../context/I18nContext';

const Sectors = () => {
  const { t } = useI18n();
  return (
    <section id="sectors" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <span className="text-xs tracking-[0.3em] uppercase text-[#f7a11a] font-semibold">{t('sectors.eyebrow')}</span>
            <h2 className="mt-4 text-4xl lg:text-5xl font-black text-slate-900 leading-tight tracking-tight">
              {t('sectors.title1')}<br /><span className="text-slate-400">{t('sectors.title2')}</span>
            </h2>
          </div>
          <p className="text-slate-600 max-w-md leading-relaxed">{t('sectors.desc')}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {sectors.map((s) => (
            <div key={s.id} className="group relative overflow-hidden aspect-square bg-slate-100">
              <img src={s.image} alt={s.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10 group-hover:from-[#0b2545] group-hover:via-[#0b2545]/60 transition-colors" />
              <div className="absolute inset-0 p-5 flex items-end">
                <h3 className="text-white font-bold text-base lg:text-lg leading-tight">{s.title}</h3>
              </div>
              <div className="absolute top-4 left-4 w-8 h-8 border border-white/40 flex items-center justify-center text-white text-xs font-bold group-hover:bg-[#f7a11a] group-hover:border-[#f7a11a] group-hover:text-slate-900 transition-colors">
                {String(s.id).padStart(2, '0')}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sectors;
